export const MILESTONE_MODAL_EN = {
  milestoneCompleted: 'Completed'
}

export const MILESTONE_MODAL_DE = {
  milestoneCompleted: 'Geschafft' // todo: real german words
}
